/**
 * @generated SignedSource<<94acedb7f163d1faf903f522c23a292b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InsertBaselineTemplateInput = {
  projectId: string;
  baselineTemplateId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type InsertBaselineTemplateMutation$variables = {
  input: InsertBaselineTemplateInput;
};
export type InsertBaselineTemplateMutation$data = {
  readonly insertBaselineTemplate: {
    readonly project: {
      readonly id: string;
    } | null;
  } | null;
};
export type InsertBaselineTemplateMutation = {
  variables: InsertBaselineTemplateMutation$variables;
  response: InsertBaselineTemplateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InsertBaselineTemplatePayload",
    "kind": "LinkedField",
    "name": "insertBaselineTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InsertBaselineTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InsertBaselineTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0f7e9b9d9a5b162695ef1ca05b03597c",
    "id": null,
    "metadata": {},
    "name": "InsertBaselineTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation InsertBaselineTemplateMutation(\n  $input: InsertBaselineTemplateInput!\n) {\n  insertBaselineTemplate(input: $input) {\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e9585bb6ca98f628e76811cfad40794";

export default node;
